import { Vector3 } from '@babylonjs/core';
import { MeshBuilder } from '@babylonjs/core/Meshes/meshBuilder';
import { CSG } from '@babylonjs/core/Meshes/csg';
import { LengthLocation, LengthType, SidePlateSequence, BASICLENGTHTYPE_ENUM, SIDE_PLATE_TYPE, AXES_ENUM, } from '../utils/enum';
import MeshManage from '../meshManage';
import SidePlate from '../specialHandler/sidePlate';
import SealPlate from '../specialHandler/sealPlate';
import { getCornerCabinetFrameXZ, getLengthLastFrames } from '../utils/renderUtils';
import { CORNER_CABINET_DEPTH, FARMESPACE_U_S, FRAMECATEGORY, FRAMEDEPTH_U_S, ROUND_SINK_DISTANCE, SKIRTINGBOARDCONFIG, SQUARE_CORNER_CABINET_SIDE_LENGTH, TOPFRAME_GROUND, TOPPANELCONFIG, } from '../utils/kitchenConfig';
import { isCornerCabinet, isFridge, isHighCabinet } from '../utils/templatejsonUtils';
import { getTopCabinetLengthInfo } from '../utils/lengthUtils';
class BaseLength {
    constructor(templateJson, scene, location, lengthType, copyTemplateJson) {
        this.sidePlatePositions = {
            bottom: {
                position: null,
            },
            top: {
                position: null,
            },
        };
        this.templateJson = templateJson;
        this.scene = scene;
        this.sidePlateMeshSize = { x: 0, y: 0, z: 0 }; // 侧板模型尺寸
        this.frameMeshSize = { x: 0, y: 0, z: 0 }; // 基准模型尺寸
        this.frameCenterPoint = { x: 0, y: 0, z: 0 }; // 基准模型中心点
        this.sidePlate = null;
        this.sidePlateID = null;
        this.location = location;
        this.lengthType = lengthType;
        this.sealPlate = null; // 补板实例
        this.copyTemplateJson = copyTemplateJson;
    }
    /**
       * @description: 提取侧板模型尺寸 基准模型尺寸 基准模型中心点
       * @param {*} frameJson 基准模型frame
       * @param {*} sequence 侧板放置的位置（前/后）
       * @author: Xiaohua Zhu
       */
    initSidePlatesAndFrames(frameJson, sequence) {
        const { sidePlatesArray, scene } = this;
        if (!sidePlatesArray) {
            return;
        }
        // 根据传入的侧板前后位置提取侧板
        const sidePlateJson = sequence === SidePlateSequence.First ? sidePlatesArray[0]
            : sidePlatesArray[sidePlatesArray.length - 1];
        if (!sidePlateJson)
            return;
        // 获取对应的mesh对象并实例化mesh管理器
        const sidePlateMesh = new MeshManage(scene.getMeshByName(sidePlateJson.id)); // 侧板
        const frameMesh = new MeshManage(scene.getMeshByName(frameJson.componentBasic.id)); // 基准模型
        this.sidePlate = new SidePlate(sidePlateMesh); // 侧板对象
        this.sidePlateMeshSize = sidePlateMesh.getModelSize(); // 侧板模型尺寸
        this.frameCenterPoint = frameMesh.getPosition(); // 基准模型中心点
        this.frameMeshSize = frameMesh.getModelSize(); // 基准模型尺寸
        this.sidePlateID = sidePlateJson.id; // 侧板id
        const { y: sidePlateSizeY } = sidePlateMesh.getModelSize();
        const { y: frameSizeY } = frameMesh.getModelSize();
        this.sidePlate.meshManage.mesh.scaling.y = frameSizeY / sidePlateSizeY;
    }
    initSidePlateConfig(sidePlateObj) {
        // 侧板的MeshManage对象
        const sidePlateMeshManage = new MeshManage(this.scene.getMeshByName(sidePlateObj.componentBasic.id));
        // 基准frame的MeshManage对象
        const frameMeshManage = new MeshManage(this.scene.getMeshByName(sidePlateObj.frameUUId));
        const sidePlateMeshSize = sidePlateMeshManage.getModelSize(); // 侧板模型尺寸
        const frameMeshSize = frameMeshManage.getModelSize(); // 基准模型尺寸
        const frameCenterPoint = frameMeshManage.getPosition(); // 基准模型中心点
        // 如果是冰箱顶柜的侧板 那么基准点会取反   上面frameMeshManage.getPosition  这个拿到的点跟冰箱顶柜排列时候的点不一致  暂不知道原因
        if (sidePlateObj.type === SIDE_PLATE_TYPE.refrigerator) {
            frameCenterPoint.x = -frameCenterPoint.x;
        }
        // 实例化侧板对象
        const sidePlate = new SidePlate(sidePlateMeshManage, frameMeshSize, frameCenterPoint);
        const { y: sidePlateSizeY } = sidePlateMeshSize;
        const { y: frameSizeY } = frameMeshSize;
        // 侧板高度缩放至所要贴的基准frame的高度
        sidePlate.meshManage.mesh.scaling.y = frameSizeY / sidePlateSizeY;
        // 返回基准模型尺寸，侧板对象
        return {
            frameMeshSize, sidePlate,
        };
    }
    // isFridge(frame){
    // }
    getBottomCalloutLineLength(position, sealPlatesLength) {
        var _a, _b;
        if (position === LengthLocation.Bottom) {
            const basicLength = this.templateJson[position][this.lengthType].length / 100;
            const topLastFrame = this.getLastFrameByPosition(LengthLocation.Top);
            // 最后第一柜体
            const bottomLastFrame = this.getLastFrameByPosition(LengthLocation.Bottom);
            // 最后第二个柜体
            const bottomLastSecondFrame = this.getLastFrameByPosition(LengthLocation.Bottom, 2);
            if (!bottomLastFrame || !bottomLastSecondFrame) {
                return basicLength;
            }
            const LastFrameMeshMange = new MeshManage(this.scene.getMeshByName((_a = bottomLastFrame === null || bottomLastFrame === void 0 ? void 0 : bottomLastFrame.componentBasic) === null || _a === void 0 ? void 0 : _a.id));
            const LastSecondFrameMeshMange = new MeshManage(this.scene
                .getMeshByName((_b = bottomLastSecondFrame === null || bottomLastSecondFrame === void 0 ? void 0 : bottomLastSecondFrame.componentBasic) === null || _b === void 0 ? void 0 : _b.id));
            const axes = ((this.lengthType === LengthType.Length1)
                || (this.lengthType === LengthType.Length3)) ? AXES_ENUM.x : AXES_ENUM.z;
            console.log(this.lengthType);
            // 冰箱在底柜的情况
            if ((bottomLastFrame === null || bottomLastFrame === void 0 ? void 0 : bottomLastFrame.categoryId) === FRAMECATEGORY.CATEGORY_39) {
                console.log(LastSecondFrameMeshMange.getModelSize()[axes] / 2
                    + Math.abs(LastSecondFrameMeshMange.mesh.position[axes]));
                // 获取冰箱前一个柜体的长度 加上补板的长度
                return LastSecondFrameMeshMange.getModelSize()[axes] / 2
                    + Math.abs(LastSecondFrameMeshMange.mesh.position[axes])
                    + sealPlatesLength;
            }
            // 冰箱在顶柜的情况
            if ((topLastFrame === null || topLastFrame === void 0 ? void 0 : topLastFrame.categoryId) === FRAMECATEGORY.CATEGORY_39) {
                // 获取最后一个柜体 加上补板的长度
                return LastFrameMeshMange.getModelSize()[axes] / 2 + Math.abs(LastFrameMeshMange.mesh.position[axes])
                    + sealPlatesLength;
            }
        }
        return this.templateJson[position][this.lengthType].length / 100;
    }
    /**
     *
     * @param meshManage
     * @description 初始化补板实例
     */
    initSealPlate(sealPlateData, _this) {
        this.sealPlate = new SealPlate(this.scene, sealPlateData);
        // 添加补板到模型管理器（清楚模型使用
        this.sealPlate.setSealPlateToManage(sealPlateData, _this);
    }
    /**
       * 挖洞
       * @param holePosition 洞的定位
       * @param holeSize 洞的尺寸
       * @param textureImage 创建新的挖孔台面 来顶替旧的台面  需要给新台面设置原有的贴图
       * @param topPanel 台面实例 需要设置台面的mesh来控制
       */
    createHole(holePosition, holeSize, textureImage, topPanel, sinkComponentId) {
        if (sinkComponentId === 1754) {
            this.createSpceialHole(holePosition, holeSize, textureImage, topPanel);
            return;
        }
        const hole = MeshBuilder.CreateBox('Hole', holeSize, this.scene);
        hole.position = new Vector3(holePosition.x, holePosition.y, holePosition.z);
        const orginCSG = CSG.FromMesh(topPanel.mesh);
        const holeCSG = CSG.FromMesh(hole);
        const resultCSG = orginCSG.subtract(holeCSG);
        const finnallyPipe = resultCSG.toMesh('finallyTopPanel', null, this.scene);
        if (textureImage) {
            const myMaterial = topPanel.getMaterial(textureImage);
            finnallyPipe.material = myMaterial;
        }
        hole.dispose();
        topPanel.mesh.dispose();
        this.scene.removeMesh(hole);
        this.scene.removeMesh(topPanel.mesh);
        // eslint-disable-next-line
        topPanel.mesh = finnallyPipe;
    }
    createSpceialHole(holePosition, holeSize, textureImage, topPanel) {
        const hole = MeshBuilder.CreateBox('Hole', holeSize, this.scene);
        hole.position = new Vector3(holePosition.x, holePosition.y, holePosition.z);
        const squareSize = {
            height: holeSize.height,
            width: ROUND_SINK_DISTANCE,
            depth: ROUND_SINK_DISTANCE,
        };
        const square1 = MeshBuilder.CreateBox('square1', squareSize, this.scene);
        const square2 = MeshBuilder.CreateBox('square2', squareSize, this.scene);
        const square3 = MeshBuilder.CreateBox('square3', squareSize, this.scene);
        const square4 = MeshBuilder.CreateBox('square4', squareSize, this.scene);
        // hole的position的四个角
        square1.position = new Vector3(holePosition.x + holeSize.width / 2 - ROUND_SINK_DISTANCE / 2, holePosition.y, holePosition.z + holeSize.depth / 2 - ROUND_SINK_DISTANCE / 2);
        square2.position = new Vector3(holePosition.x - holeSize.width / 2 + ROUND_SINK_DISTANCE / 2, holePosition.y, holePosition.z + holeSize.depth / 2 - ROUND_SINK_DISTANCE / 2);
        square3.position = new Vector3(holePosition.x + holeSize.width / 2 - ROUND_SINK_DISTANCE / 2, holePosition.y, holePosition.z - holeSize.depth / 2 + ROUND_SINK_DISTANCE / 2);
        square4.position = new Vector3(holePosition.x - holeSize.width / 2 + ROUND_SINK_DISTANCE / 2, holePosition.y, holePosition.z - holeSize.depth / 2 + ROUND_SINK_DISTANCE / 2);
        const square1CSG = CSG.FromMesh(square1);
        const square2CSG = CSG.FromMesh(square2);
        const square3CSG = CSG.FromMesh(square3);
        const square4CSG = CSG.FromMesh(square4);
        const cylinderSize = {
            height: holeSize.height,
            diameter: ROUND_SINK_DISTANCE * 2 - 0.01,
        };
        const cylinder1 = MeshBuilder.CreateCylinder('cylinder1', cylinderSize, this.scene);
        const cylinder2 = MeshBuilder.CreateCylinder('cylinder1', cylinderSize, this.scene);
        const cylinder3 = MeshBuilder.CreateCylinder('cylinder1', cylinderSize, this.scene);
        const cylinder4 = MeshBuilder.CreateCylinder('cylinder1', cylinderSize, this.scene);
        cylinder1.position = new Vector3(holePosition.x + holeSize.width / 2 - ROUND_SINK_DISTANCE, holePosition.y, holePosition.z + holeSize.depth / 2 - ROUND_SINK_DISTANCE);
        cylinder2.position = new Vector3(holePosition.x - holeSize.width / 2 + ROUND_SINK_DISTANCE, holePosition.y, holePosition.z + holeSize.depth / 2 - ROUND_SINK_DISTANCE);
        cylinder3.position = new Vector3(holePosition.x + holeSize.width / 2 - ROUND_SINK_DISTANCE, holePosition.y, holePosition.z - holeSize.depth / 2 + ROUND_SINK_DISTANCE);
        cylinder4.position = new Vector3(holePosition.x - holeSize.width / 2 + ROUND_SINK_DISTANCE, holePosition.y, holePosition.z - holeSize.depth / 2 + ROUND_SINK_DISTANCE);
        const cylinder1CSG = CSG.FromMesh(cylinder1);
        const cylinder2CSG = CSG.FromMesh(cylinder2);
        const cylinder3CSG = CSG.FromMesh(cylinder3);
        const cylinder4CSG = CSG.FromMesh(cylinder4);
        const calcCSG1 = square1CSG.subtract(cylinder1CSG);
        const calcCSG2 = square2CSG.subtract(cylinder2CSG);
        const calcCSG3 = square3CSG.subtract(cylinder3CSG);
        const calcCSG4 = square4CSG.subtract(cylinder4CSG);
        const orginCSG = CSG.FromMesh(topPanel.mesh);
        const holeCSG = CSG.FromMesh(hole);
        const rectangle = holeCSG.subtract(calcCSG1)
            .subtract(calcCSG2).subtract(calcCSG3).subtract(calcCSG4);
        const resultCSG = orginCSG.subtract(rectangle);
        const finnallyPipe = resultCSG.toMesh('finallyTopPanel', null, this.scene);
        if (textureImage) {
            const myMaterial = topPanel.getMaterial(textureImage);
            finnallyPipe.material = myMaterial;
            square1.material = myMaterial;
            square2.material = myMaterial;
            square3.material = myMaterial;
            square4.material = myMaterial;
        }
        hole.dispose();
        cylinder1.dispose();
        cylinder2.dispose();
        cylinder3.dispose();
        cylinder4.dispose();
        square1.dispose();
        square2.dispose();
        square3.dispose();
        square4.dispose();
        topPanel.mesh.dispose();
        this.scene.removeMesh(hole);
        this.scene.removeMesh(cylinder1);
        this.scene.removeMesh(cylinder2);
        this.scene.removeMesh(cylinder3);
        this.scene.removeMesh(cylinder4);
        this.scene.removeMesh(square1);
        this.scene.removeMesh(square2);
        this.scene.removeMesh(square3);
        this.scene.removeMesh(square4);
        this.scene.removeMesh(topPanel.mesh);
        // eslint-disable-next-line
        topPanel.mesh = finnallyPipe;
    }
    // 修改lengthType的绑定
    bindLengthType(lengthType) {
        this.lengthType = lengthType;
    }
    // 获取上下底柜的最后一个柜子
    getLastFrame() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const tempJson = this.copyTemplateJson ? this.copyTemplateJson : this.templateJson;
        let frames;
        let location;
        // v2.0 需要考虑高柜在顶柜还是底柜,看length值，相等在底柜，其他情况在长的那边
        if (((_c = (_b = (_a = tempJson === null || tempJson === void 0 ? void 0 : tempJson.bottom) === null || _a === void 0 ? void 0 : _a[this.lengthType]) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0)
            >= ((_f = (_e = (_d = tempJson === null || tempJson === void 0 ? void 0 : tempJson.top) === null || _d === void 0 ? void 0 : _d[this.lengthType]) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0)) {
            frames = ((_g = tempJson.bottom[this.lengthType]) === null || _g === void 0 ? void 0 : _g.frames) || [];
            location = LengthLocation.Bottom;
        }
        else {
            frames = ((_h = tempJson.top[this.lengthType]) === null || _h === void 0 ? void 0 : _h.frames) || [];
            location = LengthLocation.Bottom;
        }
        const lastFrame = frames[frames.length - 1];
        return { lastFrame, location };
    }
    // 获取底柜最后一个柜子
    getLastFrameByPosition(position, numOfLast = 1) {
        var _a;
        const tempJson = this.copyTemplateJson ? this.copyTemplateJson : this.templateJson;
        if (!tempJson[position] || !tempJson[position][this.lengthType]) {
            return null;
        }
        const frames = ((_a = tempJson[position][this.lengthType]) === null || _a === void 0 ? void 0 : _a.frames) || [];
        const lastFrame = frames[frames.length - numOfLast];
        return lastFrame;
    }
    // 获取补板长度
    getRLength() {
        return this.templateJson[this.location][this.lengthType].rlength * 0.001;
    }
    getCornerFrameWindowPosition(frame) {
        let position;
        if (frame.sink) {
            const parent = new MeshManage(this.scene.getMeshByName(frame.componentBasic.id));
            // debugger;
            const { sink } = frame;
            const child = new MeshManage(this.scene.getMeshByName(sink.componentBasic.id));
            // 如果是转角柜水槽
            if (frame.categoryId === FRAMECATEGORY.CATEGORY_27) {
                const parentPosition = parent.mesh.position;
                const parentSize = parent.getModelSize();
                const childSize = child.getModelSize();
                // 水槽在右转角柜;
                if (frame.longEdge === 1 || (frame.longEdge === 2 && frame.edge === 'length2')) {
                    // 设置水槽在右转角柜的时候跟柜子的相对位置关系 柜子长度为cx,cy,cz  水槽为sx,sy,sz
                    // x: cx/2-sx/2-边距
                    // y: cy-sy+台面高度
                    // z: 8公分/2
                    position = getCornerCabinetFrameXZ(parentPosition, parentSize, childSize, 'right', undefined, undefined);
                }
                else {
                    // 左转角柜的位置信息主要修改X的位置  跟右转角柜刚好相反 -cx/2+sx/2+边距
                    position = getCornerCabinetFrameXZ(parentPosition, parentSize, childSize, 'left', undefined, undefined);
                }
            }
        }
        return position;
    }
    /**
     * @param {string} type 类型 top/ bottom
     * @param {string} LengthName 边名
     * @description 获取每条length最后一个不是高柜的柜体meshManage
     * @returns 每条length最后一个柜体的meshManage
     * @author: Kun Yang
     */
    getLastMeshMaage(type, LengthName) {
        var _a, _b;
        const data = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a[type];
        let framseList = data[LengthName];
        // length2没有数据
        if (LengthName === BASICLENGTHTYPE_ENUM.length2 && !framseList.frames.length) {
            const newFramesData = Object.assign(Object.assign({}, data[LengthName]), { frames: ([data[BASICLENGTHTYPE_ENUM.length1].frames[0]]) });
            framseList = newFramesData;
        }
        const lastFrame = (getLengthLastFrames(framseList));
        return {
            lastLenghMesh: new MeshManage(this.scene.getMeshByName((_b = lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.componentBasic) === null || _b === void 0 ? void 0 : _b.id)),
            lastFrame,
        };
    }
    // 改变墙面颜色
    changeWallColor(wallTextureUrl, wallNormalTextureUrl, size) {
        if (this.wallNode) {
            this.wallNode.changeMatrial(wallTextureUrl, wallNormalTextureUrl, size);
        }
    }
    showWindow(show) {
        if (this.windowNode) {
            this.windowNode.show(show);
        }
    }
    /**
     * @param vertor 方向
     * @param meshManage meshManage
     * @description 旋转
     */
    /* eslint-disable class-methods-use-this */
    setMeshRotate(vertor, meshManage) {
        // 不能直接rotation.z旋转
        // eslint-disable-next-line no-param-reassign
        meshManage.mesh.rotation = vertor;
    }
    /**
     * 设置冰箱的位置
     * @param refrigerator 冰箱对象
     * @param type 底柜还是顶柜
     */
    setRefrigerator(refrigerator, type) {
        if (type === refrigerator.type) {
            refrigerator.setRefrigeratorPosition(this.sidePlatePositions[type]);
        }
    }
    // 某转角柜在所在边的长度
    getCornerCabinetLength(cornerCabinetFrame) {
        // 转角柜的长边所在的边
        const cornerCabinetLoneEdge = `length${cornerCabinetFrame.longEdge}`;
        // 该边为转角柜长边所在边 或 转角柜为正方形
        // eslint-disable-next-line max-len
        if (cornerCabinetLoneEdge === this.lengthType || cornerCabinetFrame.width === SQUARE_CORNER_CABINET_SIDE_LENGTH) {
            // true就加上这个转角柜的frames的width
            return cornerCabinetFrame.width;
        }
        // flase就加上转角柜短边的常量
        return CORNER_CABINET_DEPTH;
    }
    // 某边上一条边的转角柜 在该边的长度
    getCornerCabinetInThisLength(position) {
        var _a;
        let length = 0;
        // 这条边是length几 以便找到上一条边的对象
        const lengthTypeNum = parseInt(this.lengthType[6], 10);
        // 拿到上一条边的第一个frames对象
        const prevLengthFrames = (_a = this.templateJson[position][`length${lengthTypeNum - 1}`]) === null || _a === void 0 ? void 0 : _a.frames;
        // 过滤出上一条边的转角柜
        const prevLengthCorner = prevLengthFrames === null || prevLengthFrames === void 0 ? void 0 : prevLengthFrames.filter((item) => isCornerCabinet(item.categoryId))[0];
        if (prevLengthCorner) {
            // 上一条边的转角柜 在该边的长度
            length += this.getCornerCabinetLength(prevLengthCorner);
        }
        return length;
    }
    // 获取这条边柜体的长度和(不包括冰箱)
    getLengthByAddBasicFrames(lengthJson, position = this.location) {
        let length = 0;
        // 遍历frames数组 累加每一个frame的width
        lengthJson.frames.forEach((element) => {
            // 加上转角柜的width
            if (isCornerCabinet(element.categoryId)) {
                length += this.getCornerCabinetLength(element);
                // 加上其他不为冰箱的frame的长度
            }
            else if (!isFridge(element.categoryId)) {
                length += element.width;
            }
        });
        // 加上 rlength
        length += lengthJson.rlength;
        // 加上 上一条边的转角柜 在该边的长度
        length += this.getCornerCabinetInThisLength(position);
        return length;
    }
    // 标线长度 通过累加各种frame以及做相应的特殊处理
    getLengthByAddAllFrames(position) {
        var _a, _b, _c;
        // 标线总长度
        let lengthOfFrames = 0;
        // 拿到该边的length对象
        const lengthJson = this.templateJson[position][this.lengthType];
        // 获取这个对象中frames的长度（不包括冰箱）
        const basicFramesLength = this.getLengthByAddBasicFrames(lengthJson);
        lengthOfFrames += basicFramesLength;
        /* start--------------顶柜标线特殊处理--------------start */
        /*
          冰箱或高柜在底柜的情况 顶柜要做特殊处理
          一、有高柜没冰箱
            1、顶柜贴合高柜 顶柜标线 需要标到 高柜
            2、顶柜不贴合高柜 顶柜标线 只要标到 顶柜
          二、有冰箱没高柜
            1、有冰箱顶柜 顶柜标线 需要标到 冰箱顶柜
            2、没有冰箱顶柜 顶柜标线 只要标到 顶柜
          三、有冰箱有高柜
            1、顶柜贴合高柜 顶柜标线 需要标到 冰箱顶柜
            2、顶柜不贴合高柜 只需标到顶柜
        */
        if (position === LengthLocation.Top) {
            // 顶柜frames数组
            const topFrames = ((_b = (_a = this.copyTemplateJson) === null || _a === void 0 ? void 0 : _a.top[this.lengthType]) === null || _b === void 0 ? void 0 : _b.frames) || [];
            // 底柜rames数组
            const bottomFrames = ((_c = this.copyTemplateJson) === null || _c === void 0 ? void 0 : _c.bottom[this.lengthType].frames) || [];
            /* start--------------高柜的特殊处理--------------start */
            // 高柜长度
            let highCabinetLength = 0;
            // 是否有高柜
            let hasHighCabinet = false;
            // 顶柜的基础frames长度
            const topBasicFramesLength = basicFramesLength;
            // 底柜length对象
            const bottomLengthJson = this.templateJson.bottom[this.lengthType];
            // 底柜的标准frames长度
            const bottomBasicFramesLength = this.getLengthByAddBasicFrames(bottomLengthJson, LengthLocation.Bottom);
            // 底柜中找出高柜 得到高柜长度
            bottomFrames.filter((bottomFrame) => isHighCabinet(bottomFrame.categoryId)).forEach((element) => {
                if (element) {
                    hasHighCabinet = true;
                    highCabinetLength += element.width;
                }
            });
            // （顶柜+高柜）等于(底柜) 说明顶柜紧贴底柜的高柜
            const topLengthNextToHighCabinet = topBasicFramesLength + highCabinetLength === bottomBasicFramesLength;
            // 如果底柜有高柜 并且顶柜紧贴底柜的高柜  顶柜的标线需要加上高柜长度
            if (hasHighCabinet && topLengthNextToHighCabinet) {
                lengthOfFrames += highCabinetLength;
            }
            /* end--------------高柜的特殊处理--------------end */
            /* start--------------冰箱顶柜特殊处理--------------start */
            /*
              两种情况 顶柜标线需要加冰箱顶柜长度
              1、有高柜，顶柜紧贴高柜，冰箱有顶柜
              2、没有高柜，冰箱有顶柜
            */
            if ((hasHighCabinet && topLengthNextToHighCabinet) || !hasHighCabinet) {
                // 从顶柜底柜中找出冰箱以及冰箱的冰箱顶柜
                [...topFrames, ...bottomFrames].forEach((element) => {
                    var _a, _b;
                    // 找出冰箱
                    if (element && element.categoryId === FRAMECATEGORY.CATEGORY_39) {
                        // 找出冰箱顶柜
                        if (((_a = element === null || element === void 0 ? void 0 : element.fridgeArk) === null || _a === void 0 ? void 0 : _a.frames) && ((_b = element === null || element === void 0 ? void 0 : element.fridgeArk) === null || _b === void 0 ? void 0 : _b.frames.length) > 0) {
                            // 顶柜标线加上冰箱顶柜的长度
                            element.fridgeArk.frames.forEach((element) => {
                                lengthOfFrames += element.width;
                            });
                        }
                    }
                });
            }
            /* end--------------冰箱顶柜特殊处理--------------end */
        }
        if (position === LengthLocation.Bottom) {
            if (this.templateJson.bottom.type === 'U_S') {
                switch (this.lengthType) {
                    case LengthType.Length2:
                        lengthOfFrames += FRAMEDEPTH_U_S.U_S * 100;
                        break;
                    case LengthType.Length3:
                        lengthOfFrames += FARMESPACE_U_S * 100;
                        break;
                    default:
                        break;
                }
            }
        }
        /* end--------------顶柜标线特殊处理--------------end */
        return { length: lengthOfFrames / 100, lengthValue: lengthOfFrames };
    }
    isLTopCabineChanged(position) {
        var _a;
        return position === LengthLocation.Top && this.templateJson.top.type === 'L'
            && getTopCabinetLengthInfo((_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.top).length.includes('length3');
    }
    // 获取长度标线的高度
    getCalloutLineTopToGround(position) {
        if (position === LengthLocation.Top && !this.isOnlyHighCabinet()) {
            return TOPFRAME_GROUND(this.templateJson);
        }
        let height = SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT;
        if (this.templateJson.bottom.highAndLow) {
            height += 0.8;
        }
        else {
            height += this.templateJson.bottom.height / 100;
        }
        return height;
    }
    // 获取高度标线的起始点高度 从低到高画高度标线
    getCalloutLineHeightHeight() {
        if (this.location === LengthLocation.Top) {
            return TOPFRAME_GROUND(this.templateJson) - this.templateJson.top.height / 100;
        }
        return 0;
    }
    // 获取高度标线的长度（高低水槽柜）
    getCalloutLineHeightLength() {
        // 顶柜高度标线 直接拿业务数据
        if (this.location === LengthLocation.Top) {
            const topHeight = this.templateJson.top.height / 100;
            return {
                startHeight: topHeight,
                endHeight: topHeight,
            };
        }
        // 底柜的台面踢脚线高度
        const bottomExtraHeight = SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT;
        // 台面的业务数据高度
        const bottomHeight = this.templateJson.bottom.height / 100 + bottomExtraHeight;
        // 没有高低柜情况直接拿业务数据
        if (!this.templateJson.bottom.highAndLow) {
            return {
                startHeight: bottomHeight,
                endHeight: bottomHeight,
            };
        }
        // 过滤掉当前长度中的高柜
        const framesWithoutHigh = [...this.templateJson.bottom[this.lengthType].frames].filter((item) => !isHighCabinet(item.categoryId));
        // 除高柜以外无柜体拿 0.8高度
        if (framesWithoutHigh.length === 0) {
            return {
                startHeight: 0.8 + bottomExtraHeight,
                endHeight: 0.8 + bottomExtraHeight,
            };
        }
        // 高低柜情况 拿到该边两头的高度
        return {
            startHeight: framesWithoutHigh[0].componentBasic.height / 1000 + bottomExtraHeight,
            endHeight: framesWithoutHigh[framesWithoutHigh.length - 1].componentBasic.height / 1000 + bottomExtraHeight,
        };
    }
    getCalloutLineDepthLength() {
        if (this.location === LengthLocation.Top) {
            return FRAMEDEPTH_U_S.TOP;
        }
        if (this.templateJson.bottom.type === 'U_S'
            && this.lengthType === LengthType.Length3) {
            return FRAMEDEPTH_U_S.U_S;
        }
        return FRAMEDEPTH_U_S.BOTTOM;
    }
    isOnlyHighCabinet() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (this.lengthType !== LengthType.Length3) {
            return false;
        }
        if (!((_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.top)) {
            return false;
        }
        const topLength1 = (_d = (_c = (_b = this.templateJson) === null || _b === void 0 ? void 0 : _b.top) === null || _c === void 0 ? void 0 : _c.length3) === null || _d === void 0 ? void 0 : _d.frames;
        const bottomLength1 = (_g = (_f = (_e = this.templateJson) === null || _e === void 0 ? void 0 : _e.bottom) === null || _f === void 0 ? void 0 : _f.length3) === null || _g === void 0 ? void 0 : _g.frames;
        if (isHighCabinet(topLength1[0].categoryId) && bottomLength1.length === 1) {
            return true;
        }
        return false;
    }
}
export default BaseLength;
